import * as React from "react";
import { gql, useMutation, ApolloError, MutationTuple } from "@apollo/client";
import {
  UpdateRepContactMutationMutation,
  UpdateRepContactMutationMutationVariables
} from "../../../../../../schemaTypes";

export const updateRepContactMutation = gql`
mutation UpdateRepContactMutation(
    $id: String!, 
    $input: UpdateRepContactInput!
) {
    updateRepContact(
        id: $id, 
        input: $input
    ) {
        errors {
            path
            message
        }
        message
    }
  }
`;

interface Props {
    children: (data: {
        updateRepContact: MutationTuple<
            UpdateRepContactMutationMutation,
            UpdateRepContactMutationMutationVariables
        >[0];
        loading: boolean;
        error?: ApolloError;
        data?: UpdateRepContactMutationMutation;
        errors?: { path: string; message: string }[] | null;
        message?: string | null;
    }) => React.ReactElement | null;
}

export const UpdateRepContact: React.FC<Props> = ({ children }) => {
    const [updateRepContact, { loading, error, data }] = useMutation<UpdateRepContactMutationMutation, UpdateRepContactMutationMutationVariables>(updateRepContactMutation);

    const errorsRaw = data?.updateRepContact?.errors ?? null;
    const errors = Array.isArray(errorsRaw)
        ? errorsRaw.filter((e): e is { path: string; message: string } => !!e)
        : errorsRaw;
    const message = data?.updateRepContact?.message ?? null;

    return children({
        updateRepContact,
        loading,
        error,
        data: data ?? undefined,
        errors,
        message
    });
};
